import { Refusals, refusalReason } from "../../../utils/refusalMessageKey";
import { PHONE_CODE_REFUSALS } from "../../../utils/phoneCodeRefusals";

export const SIGNING_REFUSALS: Refusals = {
  ...PHONE_CODE_REFUSALS,
  LINK_INVALID: "signing.linkInvalid.message",
  ALREADY_SIGNED: "signing.alreadySigned.message",
  DECLINED: "signing.declined.message",
  EXPIRED: "signing.expired.message",
  NO_PHONE: "signing.noPhone",
};

const FINAL_REASONS = ["LINK_INVALID", "ALREADY_SIGNED", "DECLINED", "EXPIRED"];

/** A refusal that no new code can lift. */
export const isFinalSigningRefusal = (error: unknown) =>
  FINAL_REASONS.includes(refusalReason(error) ?? "");
